export default {
  data() {
    return {
      toggled: false,
      value: 10,
      updateValue: 22,
    };
  },
  methods: {
    onClick() {
      this.value = this.updateValue;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/debug/debug.js